<template>
    <md-card-content>
        <div class="md-layout pb-3">
            <div class="md-layout-item">
                <md-field class="md-invalid">
                    <label>Nom</label>
                    <md-input v-model="product.name" name="name" type="text" maxlength="45" required></md-input>
                    <validation-error :errors="apiValidationErrors.name"/>
                </md-field>
            </div>
        </div>
    </md-card-content>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "ProductForm",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        product: {
            type: Object,
            default() {
                return {
                    name: '',
                }
            }
        },
        errors: Array,
    },
    methods: {
        addProductEvent() {
            this.$emit('add-product')
        }
    },
    watch: {
        errors: function (newVal, oldVal) {
            this.resetApiValidation();
            if (newVal) {
                this.setApiValidation(newVal);
            }
        }
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-layout-item {
        h4 {
            font-size: .75rem;
        }

        .md-button {
            width: auto;
            margin: 0;
            padding: 5px;
            height: 27px;
            min-width: 27px;
            line-height: 27px;

            .md-icon {
                font-size: .875rem !important;
                min-width: .875rem !important;
                height: .875rem !important;
            }
        }
    }
}
</style>
